import React, {useState} from 'react';
import SideNavItem from './SideNavItem';
import { Drawer, List, IconButton, Box, Divider, useTheme } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BookIcon from '@mui/icons-material/Book';
import CloseIcon from '@mui/icons-material/Close';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import QuestionsIcon from '@mui/icons-material/QuestionAnswer';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { Gavel, Poll, School, Shield } from '@mui/icons-material';
import { toMaterials, toProgress, toSurveyStart } from '../../utils/routes';
import Logo from '../../assets/Logo.png';
import { useTranslation } from 'react-i18next';

export default function SideNav(props) {

    const theme = useTheme();
    const [selected, setSelected] = useState("Start");

    const {t} = useTranslation()

    const navEntries = [
        {
          link: "/home",
          name: t("navigationCat1"),
          icon: <HomeIcon color="primary" />
        },
        {
          link: "/videos",
          name: t("navigationCat2"),
          icon: <VideoLibraryIcon color="primary" />
        },
        {
          link: "/story",
          name: t("navigationCat3"),
          icon: <BookIcon color="primary" />
        },
        {
          link: "/learning",
          name: t("navigationCat4"),
          icon: <QuestionsIcon color="primary" />
        },
        {
            link: toSurveyStart,
            name: t("navigationCat5"),
            icon: <Poll sx={{color: theme.palette.secondary.dark}}/>,
            color: theme.palette.secondary.dark
        }
    ]

    
    const navAffiliate = [
        // {
        //     link: "/publications",
        //     name: t("navigationCat12"),
        //     icon: <School sx={{color: theme.palette.secondary.dark}}/>,
        //     color: theme.palette.secondary.dark
        // },  
        {
            link: "/impressum",
            name: t("navigationCat6"),
            icon: <Gavel color="primary" />
        },
        {
            link: "/privacy",
            name: t("navigationCat7"),
            icon: <Shield color="primary" />
        },
    ]

    const list = () => {
        return (
            <Box sx={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100vh", minWidth: "15rem"}}>
                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <IconButton onClick={(event) => props.toggleSide(false)(event)}
                                sx={{
                                    '&:hover': {
                                        cursor: "pointer",
                                        backgroundColor: "#eee"
                                    },
                                    margin: 2,
                                }}
                        >
                            <CloseIcon color="primary"
                                sx={{padding: "0.5rem"}}
                            />
                        </IconButton>
                        <Box sx={{mr: 2}}>
                            <img src={Logo} alt="Gekonnt hanDeln Logo" width={55}/>
                        </Box>

                    </Box>
                    <List>
                        {listItems(navEntries)}
                    </List>
                    <Divider />
                    <Box
                        sx={{marginTop: 1}}
                    >                
                        <SideNavItem key={"Fortschritt"} toggleSide={props.toggleSide} setSelected={setSelected} 
                                selected={selected === "Fortschritt"} name={t("navigationCat8")} link={toProgress} 
                                icon={<CardMembershipIcon color="primary" />}/>
                        <SideNavItem key={"Materialien"} toggleSide={props.toggleSide} setSelected={setSelected} 
                                selected={selected === "Materialien"} name={t("navigationCat9")} link={toMaterials} 
                                icon={<NoteAltIcon color="primary" />}/>
                    </Box>

                </Box>
                <List>
                    {listItems(navAffiliate)}
                </List>
            </Box>
        )
    };

    const listItems = (entries) => {
    let listItemsTemp = [];

    for (let item of entries) {
        let active = selected === item.name;
        listItemsTemp.push(
            <SideNavItem key={item.name} toggleSide={props.toggleSide} setSelected={setSelected} 
                            selected={active} name={item.name} link={item.link} color={item.color}
                            icon={item.icon}/>
            )
        }
        return listItemsTemp;
    }

    return (
        <Drawer open={props.sideOpen} onClose={props.toggleSide(false)}
            sx={{
                maxWidth: "50vw"
            }}
        >
            {list()}
        </Drawer>
    )
}